const ROWS = [
  { t: "IMC (OMS)", items: [["Bom", "18,5 – 24,9", "green"], ["Sobrepeso", "25,0 – 29,9", "yellow"], ["Atenção", "< 18,5 ou ≥ 30", "red"]] },
  { t: "Gordura Corporal — Mulheres", items: [["18–39", "21% – 32%", "green"], ["40–59", "23% – 33%", "green"], ["60+", "24% – 35%", "green"], ["Acima do máx", "Vermelho", "red"]] },
  { t: "Gordura Corporal — Homens", items: [["18–39", "8% – 19%", "green"], ["40–59", "11% – 21%", "green"], ["60+", "13% – 24%", "green"], ["Acima do máx", "Vermelho", "red"]] },
  { t: "Massa Muscular — Homens", items: [["18–35", "≥ 34%", "green"], ["36–55", "≥ 30%", "green"], ["56–75", "≥ 27%", "green"], ["Abaixo do mín", "Vermelho", "red"]] },
  { t: "Massa Muscular — Mulheres", items: [["18–35", "≥ 26%", "green"], ["36–55", "≥ 24%", "green"], ["56–75", "≥ 22%", "green"], ["Abaixo do mín", "Vermelho", "red"]] },
  { t: "Gordura Visceral", items: [["Bom", "Nível 1 – 9", "green"], ["Atenção", "Nível 10 – 30", "red"]] },
  { t: "Idade Corporal", items: [["Bom", "≤ idade real", "green"], ["Atenção", "> idade real", "red"]] },
];

const dot = { green: "bg-emerald-500", yellow: "bg-amber-500", red: "bg-red-500" };

export default function ReferenceTable() {
  return (
    <div className="bg-[#181F2C] border border-[#263147] rounded-2xl p-5" data-testid="reference-table">
      <h3 className="text-base font-semibold font-heading text-slate-100 mb-1">Parâmetros Oficiais de Referência</h3>
      <p className="text-xs text-slate-500 mb-4">Verde = dentro do recomendado • Vermelho = precisa de atenção</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {ROWS.map((r) => (
          <div key={r.t} className="bg-[#0F1520] border border-[#263147] rounded-xl p-3">
            <p className="text-sm font-medium text-slate-200 mb-2">{r.t}</p>
            <div className="space-y-1">
              {r.items.map(([lbl, val, c], i) => (
                <div key={i} className="flex items-center gap-2 text-xs">
                  <span className={`w-2 h-2 rounded-full ${dot[c]}`} />
                  <span className="text-slate-400 flex-1">{lbl}</span>
                  <span className="text-slate-300 font-medium">{val}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
